import { features } from "./features"
import { screens } from "./screens"
export let sysComponentsActions = { features, screens }
